import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./components/Cssfile/Navbar.css";

const Navbar = () => {

  const navigate = useNavigate();

  // Logout Function
  const handleLogout = async () => {
    try {

      await axios.get("/user/logout");

      toast.success(("Logout Successfully"),  { position: "top-center"});

      navigate("/");

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
        {/* <NavLink exact className="navbar-brand" to={"/"}>Login</NavLink> */}
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">

      <div className="container-fluid">

        {/* Logo */}
        <NavLink className="navbar-brand" to="/Home">
          Home
        </NavLink>

        {/* Mobile Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="navbar">

          <ul className="navbar-nav me-auto">

            {/* Live Reports */}
            <li className="nav-item dropdown">

              <a
                className="nav-link dropdown-toggle"
                href="/"
                role="button"
                data-bs-toggle="dropdown"
              >
                Live Reports
              </a>

              <ul className="dropdown-menu">

                <li>
                  <NavLink className="dropdown-item" to="/Tcsreport">
                    Live SAP Sales ZSM
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/Sapsoreport">
                    Live SAP Sales SO/ASM
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/Tcssoreport">
                    Live TCS Sales SO/ASM
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/Tcssaleshisreport">
                    Live Sales History
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/Tcsinventory">
                    Live SAP Item Inventory
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/MonthendReport">
                    Month End Reports
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/Reportstillmonth">
                    Pharma Till Months
                  </NavLink>
                </li>

              </ul>
            </li>

            {/* SAP Live Sales */}
            <li className="nav-item dropdown">

              <a
                className="nav-link dropdown-toggle"
                href="/"
                role="button"
                data-bs-toggle="dropdown"
              >
                Live Current Month SAP Sales
              </a>

              <ul className="dropdown-menu">
              <li>
                  <NavLink className="dropdown-item" to="/Livesapzsmreport">
                    FM Live SAP Sales ZSM
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>

                <li>
                  <NavLink className="dropdown-item" to="/Livesapsoreport">
                    FM Live SAP Sales SO/ASM
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
              <li>
              <li>
                  <NavLink className="dropdown-item" to="/Sapinventory">
                    SAP Live Inventory Report
                  </NavLink>
                </li>
                
                <li><hr className="dropdown-divider" /></li>
                  <NavLink className="dropdown-item" to="/Dashboard">
                    FM Dash Board
                  </NavLink>
                </li>
                

                
                

              </ul>
            </li>

            {/* Master */}
            <li className="nav-item dropdown">

              <a
                className="nav-link dropdown-toggle"
                href="/"
                role="button"
                data-bs-toggle="dropdown"
              >
                Master
              </a>

              <ul className="dropdown-menu">

                <li>
                  <NavLink className="dropdown-item" to="/Signup">
                    Signup
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/Employee">
                    Employee Management
                  </NavLink>
                </li>

              </ul>
            </li>

            {/* ITSM */}
            <li className="nav-item dropdown">

              <a
                className="nav-link dropdown-toggle"
                href="/"
                role="button"
                data-bs-toggle="dropdown"
              >
                ITSM-Ticket
              </a>

              <ul className="dropdown-menu">

                <li>
                  <NavLink className="dropdown-item" to="/ticketlist">
                    Ticket List
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/ticketcreate">
                    New Ticket
                  </NavLink>
                </li>

              </ul>
            </li>

            {/* Change Password */}
            <li className="nav-item">
              <NavLink className="nav-link" to="/Password">
                Change Password
              </NavLink>
            </li>

          </ul>

          {/* Logout Button */}
          <button
            className="btn btn-danger btn-sm"
            onClick={handleLogout}
          >
            Logout
          </button>

        </div>
      </div>
    </nav>
    </>
  );
};

export default Navbar;